module.exports = __webpack_public_path__ + "static/media/2971.ed44881a.jpg";